//
//
//
//
import moment from "moment";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      initialTimestamp: null,
      displayTimestamp: null,
      distance: null,
      timer: null
    };
  },
  computed: {
    formattedTime: function formattedTime() {
      return moment(new Date(this.initialTimestamp + this.distance)).format(this.spec.format || "YYYY-MM-DD hh:mm:ss");
    }
  },
  methods: {
    $ready: function $ready() {
      this.displayTimestamp = Date.parse(this.spec.value);
      this.initialTimestamp = new Date().getTime();

      if (this.spec.tick === true) {
        this.timer = setInterval(this.tick, 100);
      }
    },
    $tearDown: function $tearDown() {
      console.log("TimeTicker destroyed");

      if (this.timer != null) {
        clearInterval(this.timer);
        console.log("Timer stopped: ".concat(this.timer));
      }
    },
    tick: function tick() {
      this.distance = new Date().getTime() - this.initialTimestamp;
    }
  }
};